import type { ReactNode, RefObject } from 'react';
import { Link } from 'react-router';
import { sv } from '@aldorock-fordon/shared/sv';
import { useState } from 'react';
import { HelpButton, HelpPanel } from './Help.tsx';

export type Crumb = { to?: string; label: string };

export function PageHead({
  crumbs,
  title,
  titleRef,
  status,
  actions,
  help,
}: {
  crumbs?: Crumb[];
  title: string;
  titleRef: RefObject<HTMLHeadingElement | null>;
  status?: ReactNode;
  actions?: ReactNode;
  /** The help screen key; every page has one. */
  help?: string;
}) {
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <>
      {crumbs?.length ? (
        <nav className="crumbs" aria-label={sv.app.breadcrumbs}>
          {crumbs.map((c, i) => (
            <span key={i}>
              {i > 0 ? ' / ' : null}
              {c.to ? <Link to={c.to}>{c.label}</Link> : <span aria-current="page">{c.label}</span>}
            </span>
          ))}
        </nav>
      ) : null}
      <div className="app-head">
        <h1 ref={titleRef} tabIndex={-1}>
          {title}
        </h1>
        {status}
        {actions || help ? (
          <div className="actions no-print">
            {help ? (
              <HelpButton screen={help} open={helpOpen} onToggle={() => setHelpOpen((v) => !v)} />
            ) : null}
            {actions}
          </div>
        ) : null}
      </div>
      {help && helpOpen ? <HelpPanel screen={help} /> : null}
    </>
  );
}
